import { Selector } from '@ngxs/store';
import { DownloadsStateModel } from '@store/models/downloads.model';
import { DownloadsState } from '@store/states/downloads.state';

export class DownloadsSelectors {
    @Selector([DownloadsState])
    static downloads(state: DownloadsStateModel) {
        return state.downloads;
    }

    @Selector([DownloadsState])
    static downloadsLoading(state: DownloadsStateModel) {
        return state.loading;
    }

    @Selector([DownloadsState])
    static downloadsLoaded(state: DownloadsStateModel) {
        return state.loaded;
    }

    @Selector([DownloadsState])
    static downloadsError(state: DownloadsStateModel) {
        return state.error;
    }
}
